module.exports = __webpack_public_path__ + "img/itapolis.d221a29d.png";